import * as signalR from '@microsoft/signalr';
import { SIGNALR_BACKEND_URL } from '../../utils/config';

const signalrMiddleware = store => {
  let connection;
  // Setup worker
  const worker = new Worker(new URL('./signalrWorker.js', import.meta.url));
  // Receive batches from worker
  worker.onmessage = (e) => {
    const { type, payload } = e.data;
    switch (type) {
      case 'TaskUpdated':
        store.dispatch({ type: 'tasks/batchUpdate', payload });
        break;
      case 'TaskCreated':
        store.dispatch({ type: 'tasks/batchCreate', payload });
        break;
      case 'PatrolUpdated':
        store.dispatch({ type: 'patrols/batchUpdate', payload });
        break;
    }
  };
  return next => action => {
    switch (action.type) {
      case 'WS_CONNECT': {
        if (!connection) {
          connection = new signalR.HubConnectionBuilder()
            .withUrl(SIGNALR_BACKEND_URL, {
              skipNegotiation: true,
              transport: signalR.HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Debug)
            .build();
          connection.start()
            .then(() => console.log('SignalR Connected'))
            .catch(err => console.error('SignalR Connection Error:', err));
          connection.on('TaskUpdated', data => {
            worker.postMessage({ type: 'TaskUpdated', payload: data });
          });
          connection.on('TaskCreated', data => {
            worker.postMessage({ type: 'TaskCreated', payload: data });
          });
          connection.on('PatrolUpdated', data => {
            worker.postMessage({ type: 'PatrolUpdated', payload: data });
          });

        }
        break;
      }
    }
    return next(action);
  };
};

export default signalrMiddleware;

